<!--头部导航页-->
<template>
  <div style="font-family: Alibaba">
    <!-- PC端-->
    <div class="PC_box">
      <div class="header">
        <!--LOGO-->
        <div class='logo' >
          <a href="#" @click="navigateIndex">
            <img src="../../assets/images/heard01.png" alt="logo" />
          </a>
        </div>
        <!--选项卡-->
        <div class="tabs">
          <div class="buts">
            <el-button type="text" class="A" slot="reference" @click="navigateIndex">首页</el-button>
          </div>

          <el-popover
            v-for="(item, index) in popoverItems"
            :key="index"
            class="buts"
            placement="bottom"
            trigger="hover"
          >
            <ul class="optionList">
              <li v-for="entry in item.entries" :key="entry.title">
                <h4 v-if="item.entries.length > 1">{{ entry.title }}</h4>
                <p v-for="link in entry.links" :key="link.text">
                  <a v-if="link.outerJoin === false" @click="navigateTo(link)" target="_blank">{{ link.text }}</a>
                  <a v-else @click.prevent="openOuterJoin(link)" target="_blank">{{ link.text }}</a>
                </p>
              </li>
            </ul>
            <el-button type="text" :class="item.buttonClass" slot="reference">{{ item.buttonName }}</el-button>
          </el-popover>
        </div>
        <div class="search">
          <el-select
            ref="headerSearchSelect"
            v-model="search"
            :remote-method="querySearch"
            filterable
            default-first-option
            multiple
            remote
            reserve-keyword
            size="small"
            placeholder="查询"
            class="el_select"
            @change="change"
          >
            <el-option v-for="option in options" :key="option.item.id" :value="option.item" :label="option.item.title.join(' > ')" />
          </el-select>
        </div>

      </div>
    </div>

    <!-- 手机端-->
    <div class="mobile_box">
      <ul class='top'>
        <li>
          <el-button icon="el-icon-s-operation" @click="closeDestroy" type="text">
          </el-button>
        </li>
        <li>广东资环新能科技有限公司</li>
        <li>
<!--          <el-button icon="el-icon-search"  @click="centerDialogVisible = true" type="text"></el-button>-->
<!--          <el-dialog-->
<!--            :visible.sync="centerDialogVisible"-->
<!--            width="90%"-->
<!--            center>-->
<!--            <div class="search">-->
<!--              <el-select-->
<!--                ref="headerSearchSelect"-->
<!--                v-model="search"-->
<!--                :remote-method="querySearch"-->
<!--                filterable-->
<!--                default-first-option-->
<!--                remote-->
<!--                placeholder="查询"-->
<!--                style="width: 100%"-->
<!--                class="header-search-select"-->
<!--                @change="change"-->
<!--              >-->
<!--                <el-option v-for="option in options" :key="option.item.id" :value="option.item" :label="option.item.title.join(' > ')" />-->
<!--              </el-select>-->
<!--            </div>-->
<!--          </el-dialog>-->
        </li>
      </ul>
      <el-drawer
        direction="ltr"
        :modal='false'
        style='margin-top: 60px'
        :visible.sync="drawer"
        size="100%"
        :with-header="false">
        <div>
          <!--下拉选项-->
          <el-collapse class='collapse' v-model="activeNames" @change="handleChange">
            <p class="but"><a href="#" style="font-size: 16px" @click="navigateIndex" target="_blank">首页</a></p>
            <el-collapse-item
              v-for="(item, index) in popoverItems"
              :key="item.id"
              :title="item.buttonName"
              :name="index"
            >
              <div v-for="entry in item.entries" :key="entry.id">
                <h5 v-if="item.entries.length > 1">{{ entry.title }}</h5>
                <p v-for="link in entry.links" :key="link.id">
                  <a @click="navigateMobileTo(link)">{{ link.text }}</a>
                </p>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-drawer>
    </div>
  </div>
</template>
<script>
import { selectHeards } from '@/api/zh'

export default {
  // components: {
  //   Search
  // },
  created () {
    this.getHeardData()
  },
  data () {
    return {
      search: '',
      drawer: false,
      show: false,
      activeNames: [],
      centerDialogVisible: false,
      search_input: '',
      popoverItems: [],
      options: []
    }
  },
  mounted () {
  },
  methods: {
    querySearch (query) {
      if (query !== '') {
        this.options = this.popoverItems.reduce((acc, item) => {
          item.entries.forEach(entry => {
            entry.links.forEach(link => {
              if (link.text.toLowerCase().includes(query.toLowerCase())) {
                acc.push({
                  item: {
                    title: [item.buttonName, entry.title, link.text],
                    id: link.id,
                    path: link.href
                  }
                })
              }
            })
          })
          return acc
        }, [])
      } else {
        this.options = []
      }
    },
    change(val) {
      this.search = ''
      const routeData = this.$router.resolve({
        path: val.path,
        query: { tabId: val.id }
      })
      this.options = []
      window.open(routeData.href, '_blank')

    },
    click() {
      this.show = !this.show
      if (this.show) {
      }
    },
    /** 获取heard数据 */
    getHeardData () {
      selectHeards().then(res => {
        this.popoverItems = res.data
      })
    },
    /** 首页 */
    navigateIndex () {
      // window.location.href = '/index'
      this.$router.push({
        path: '/index'
      })
    },
    /** 链接跳转
     *  const newWindow = window.open()
     *  const routeData = this.$router.resolve({ path: link.href, params: { id: 123456 } })
     *  newWindow.location.href = routeData.href
     */
    navigateTo (link) {
      const routeData = this.$router.resolve({
        path: link.href,
        query: { tabId: link.id }
      })
      window.open(routeData.href, '_blank')
    },
    navigateMobileTo (link) {
      this.$router.push({
        path: link.href,
        query: { tabId: link.id }
      })
    },

    handleChange (val) {
      console.log(val)
    },
    closeDestroy (val) {
      if (this.drawer) {
        this.drawer = false
      } else {
        this.drawer = true
      }
    },
    /** 查询 */
    searchInp () {

    },
    /** 打开外连接 */
    openOuterJoin (link) {
      // 使用完整URL并直接在当前窗口打开外连接
      window.open(link.href, '_blank')
    }

  }
}
</script>
<style scoped>
::v-deep .collapse .el-collapse-item__header {
  font-size: 16px !important;
}
.right-menu-item {
  display: inline-block;
  padding: 0 8px;
  height: 100%;
  font-size: 18px;
  color: #5a5e66;
  vertical-align: text-bottom;

  &.hover-effect {
    cursor: pointer;
    transition: background .3s;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
}
.el_select{
  width: 180px;
}
::v-deep .el-input--suffix .el-input__inner{
  width: 180px;
  border-radius: 8px;
  padding:0 10px ;
  border: 1px solid #999999;
}
</style>
